module.exports = function() {
	return new Worker(__webpack_public_path__ + "575fda744365e513818d.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader!./src/app/lunr_worker.js
// module id = ./node_modules/worker-loader/index.js!./src/app/lunr_worker.js
// module chunks = main